<template>
  <div id="app">
    <div class="homeHeader">
      <div class="logo">
        <img src="@/assets/img/sy/logo.png" alt="" />
      </div>

      <ul class="navigationBar">
        <li
          v-for="(item, index) in navigationBarArr"
          :key="index"
          :class="[
            $LocalCache.getCache('navigationBarIndex') === index
              ? 'navigationBarChange'
              : ''
          ]"
          :style="index === 5 || index === 1 || index === 4 ? { position: 'relative' } : {}"
        >
          <!-- 产品中心下拉（索引1） -->
          <template v-if="index === 1">
            <el-dropdown
              trigger="hover"
              @command="handleProductDropdownClick"
              placement="bottom-start"
              class="nav-dropdown"
            >
              <span class="nav-link" @click="handleNavigationBar($event, 1)">
                {{ item }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="sub in productDropdownItems"
                  :key="sub.value"
                  :command="sub.value"
                >
                  {{ sub.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- 成功案例下拉（索引4） -->
          <template v-else-if="index === 4">
            <el-dropdown
              trigger="hover"
              @command="handleSuccessfulDropdownClick"
              placement="bottom-start"
              class="nav-dropdown"
            >
              <span class="nav-link" @click="handleNavigationBar($event, 4)">
                {{ item }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="sub in successfulDropdownItems"
                  :key="sub.value"
                  :command="sub.value"
                >
                  {{ sub.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- 政采合规下拉（索引5） -->
          <template v-else-if="index === 5">
            <el-dropdown
              trigger="hover"
              @command="handleDropdownClick"
              placement="bottom-start"
              class="nav-dropdown"
            >
              <span class="nav-link" @click="handleNavigationBar($event, 5)">
                {{ item }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="sub in dropdownItems"
                  :key="sub.value"
                  :command="sub.value"
                >
                  {{ sub.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- 其他导航项 -->
          <span v-else class="nav-link" @click="handleNavigationBar($event, index)">
            {{ item }}
          </span>
        </li>
      </ul>

      <div class="phone">
        <div class="phoneBox">
          <img src="@/assets/img/sy/tbdh.png" alt="" />
          <div class="phoneBoxRight">
            <div class="phoneBoxRight_top">咨询热线：</div>
            <div class="phoneBoxRight_bottom">18190816379</div>
          </div>
        </div>
      </div>
    </div>

    <div class="homeContent">
      <router-view />
    </div>

    <!-- 顶部导航条 -->
    <div class="topNavigation">
      <div class="topNav-container">
        <ul class="topNav-menu">
          <li
            v-for="(item, index) in topNavigationArr"
            :key="index"
            :class="{ 'active': topActiveIndex === index }"
            :style="index === 5 || index === 1 || index === 4 ? { position: 'relative' } : {}"
          >
            <!-- 产品中心下拉（顶部） -->
            <template v-if="index === 1">
              <el-dropdown
                trigger="hover"
                @command="handleTopProductDropdownClick"
                placement="bottom-start"
                class="nav-dropdown top-nav-dropdown"
              >
                <span class="nav-link" @click="handleTopNavigation(item, index)">
                  {{ item }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="sub in productDropdownItems"
                    :key="sub.value"
                    :command="sub.value"
                  >
                    {{ sub.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <!-- 成功案例下拉（顶部） -->
            <template v-else-if="index === 4">
              <el-dropdown
                trigger="hover"
                @command="handleTopSuccessfulDropdownClick"
                placement="bottom-start"
                class="nav-dropdown top-nav-dropdown"
              >
                <span class="nav-link" @click="handleTopNavigation(item, index)">
                  {{ item }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="sub in successfulDropdownItems"
                    :key="sub.value"
                    :command="sub.value"
                  >
                    {{ sub.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <!-- 政采合规下拉（顶部） -->
            <template v-else-if="index === 5">
              <el-dropdown
                trigger="hover"
                @command="handleTopDropdownClick"
                placement="bottom-start"
                class="nav-dropdown top-nav-dropdown"
              >
                <span class="nav-link" @click="handleTopNavigation(item, index)">
                  {{ item }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="sub in dropdownItems"
                    :key="sub.value"
                    :command="sub.value"
                  >
                    {{ sub.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <span v-else class="nav-link" @click="handleTopNavigation(item, index)">
              {{ item }}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="homeFoot">
      <div class="homeFoot_box">
        <div class="homeFoot_boxTop">
          <div class="boxContent">
            <ul class="boxLeft">
              <li>地址：</li>
              <li>四川省成都市青羊区人民南路一段86号城市之心18J</li>
            </ul>
            <div class="boxCenter">
              <li>联系我们：</li>
              <li>
                <img src="@/assets/img/sy/sy_yx.png" alt="" class="sy_yx" />
                <span class="yx">邮箱:zhandongkj@163.com</span>
                <img src="@/assets/img/sy/sy_dh.png" alt="" class="sy_dh" />
                <span class="dh">18190816379</span>
              </li>
            </div>
            <div class="boxRight">
              <li><img src="@/assets/img/sy/code.jpg" alt="" /></li>
              <div class="boxRight-li">
                <li>关注我们：</li>
                <li class="gzh-li"><span class="gzh">公众号：林间东语</span></li>
              </div>
            </div>
          </div>
        </div>
        <div class="homeFoot_boxBottom">
          <div class="footContent">
            版权所有：Copyright © 2021.占东科技（成都）有限公司 All rights
            reserved.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ICP备案/许可证号：
            <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank" class="beian-link">蜀ICP备2026014950号-1</a>
            <img src="@/assets/img/beian.png" class="beian-icon" style="margin-left: 5px;" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010502015651" rel="noreferrer" target="_blank" class="beian-link">川公网安备51010502015651号</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 全局留言功能 -->
    <FloatingIcon :visible="true" :right="'20px'" :bottom="'20px'" :z-index="1000">
      <template>
        <div class="message-content">
          <i class="el-icon-chat-dot-round"></i>
          <span class="message-text">留言</span>
        </div>
      </template>
    </FloatingIcon>
  </div>
</template>

<script>
import User from '@/api/user.js'
import Product from '@/api/product.js'
import FloatingIcon from '@/components/floatingIcon/index.vue'
import { getCategories } from '@/utils/categoryStore.js'
import { getSuccessfulCategories } from '@/utils/successfulCategoryStore.js'

export default {
  name: 'App',
  components: {
    FloatingIcon
  },
  data () {
    return {
      topNavigationArr: [
        '首页',
        '产品中心',
        '解决方案',
        '新闻动态',
        '成功案例',
        '政采合规',
        '关于我们',
        '联系我们'
      ],
      topActiveIndex: 0,
      navigationBarArr: [
        '首页',
        '产品中心',
        '解决方案',
        '新闻动态',
        '成功案例',
        '政采合规',
        '关于我们',
        '联系我们'
      ],
      navigationBarIndex: 0,
      routerName: 'Home',
      userName: 'font-user',
      passWord: 'admin',
      // 产品分类下拉数据（动态从接口获取）
      productDropdownItems: [],
      // 成功案例分类下拉数据（动态从接口获取）
      successfulDropdownItems: [],
      // 政采合规下拉数据
      dropdownItems: [
        { label: '法规条文', value: 1 },
        { label: '法规解读', value: 2 },
        { label: '政采案例', value: 3 },
        { label: '政采合规', value: 4 },
        { label: '优惠政策', value: 5 },
        { label: '政采帮扶', value: 6 },
        { label: '项目申请指南', value: 7 }
      ]
    }
  },
  methods: {
    // ===== 获取产品分类（动态） =====
    async fetchProductCategories () {
      try {
        const categories = await getCategories()
        this.productDropdownItems = categories.map(item => ({
          label: item.name,
          value: item.id
        }))
      } catch (error) {
        console.error('获取产品分类失败', error)
      }
    },

    // ===== 获取成功案例分类（动态） =====
    async fetchSuccessfulCategories () {
      try {
        const categories = await getSuccessfulCategories()
        this.successfulDropdownItems = categories.map(item => ({
          label: item.name,
          value: item.id
        }))
      } catch (error) {
        console.error('获取成功案例分类失败', error)
      }
    },

    // ===== 产品中心下拉点击（主导航） =====
    handleProductDropdownClick (categoryId) {
      this.$LocalCache.setCath('navigationBarIndex', 1)
      this.topActiveIndex = 1
      this.$router.push({
        name: 'ProductCenter',
        query: { categoryId: categoryId }
      })
    },

    // ===== 产品中心下拉点击（顶部导航） =====
    handleTopProductDropdownClick (categoryId) {
      this.topActiveIndex = 1
      this.$LocalCache.setCath('navigationBarIndex', 1)
      this.$router.push({
        name: 'ProductCenter',
        query: { categoryId: categoryId }
      })
    },

    // ===== 成功案例下拉点击（主导航） =====
    handleSuccessfulDropdownClick (categoryId) {
      this.$LocalCache.setCath('navigationBarIndex', 4)
      this.topActiveIndex = 4
      this.$router.push({
        name: 'SuccessfulCase',
        query: { categoryId: categoryId }
      })
    },

    // ===== 成功案例下拉点击（顶部导航） =====
    handleTopSuccessfulDropdownClick (categoryId) {
      this.topActiveIndex = 4
      this.$LocalCache.setCath('navigationBarIndex', 4)
      this.$router.push({
        name: 'SuccessfulCase',
        query: { categoryId: categoryId }
      })
    },

    // ===== 政采合规下拉点击（主导航） =====
    handleDropdownClick (type) {
      this.$LocalCache.setCath('navigationBarIndex', 5)
      this.topActiveIndex = 5
      this.$router.push({
        name: 'Purchase',
        query: { purchaseType: type }
      })
    },
    // ===== 政采合规下拉点击（顶部导航） =====
    handleTopDropdownClick (type) {
      this.topActiveIndex = 5
      this.$LocalCache.setCath('navigationBarIndex', 5)
      this.$router.push({
        name: 'Purchase',
        query: { purchaseType: type }
      })
    },

    // ===== 原有导航方法 =====
    handleTopNavigation (item, index) {
      this.topActiveIndex = index
      this.$LocalCache.setCath('navigationBarIndex', index)
      this.handleNavigationBar(null, index)
    },
    handleNavigationBar (event, index) {
      this.$LocalCache.setCath('navigationBarIndex', index)
      this.topActiveIndex = index

      let targetRouteName
      switch (index) {
        case 1: targetRouteName = 'ProductCenter'; break
        case 2: targetRouteName = 'Solution'; break
        case 3: targetRouteName = 'News'; break
        case 4: targetRouteName = 'SuccessfulCase'; break
        case 5: targetRouteName = 'Purchase'; break
        case 6: targetRouteName = 'AboutUs'; break
        case 7: targetRouteName = 'ContactUs'; break
        default: targetRouteName = 'Home'
      }

      if (this.$route.name !== targetRouteName) {
        if (targetRouteName === 'Purchase') {
          this.$router.push({ name: 'Purchase' })
        } else if (targetRouteName === 'ProductCenter') {
          // 点击"产品中心"本身（非下拉项）不带分类参数
          this.$router.push({ name: 'ProductCenter' })
        } else if (targetRouteName === 'SuccessfulCase') {
          // 点击"成功案例"本身（非下拉项）不带分类参数
          this.$router.push({ name: 'SuccessfulCase' })
        } else {
          this.$router.push({ name: targetRouteName })
        }
      }
    },

    // ===== 登录及初始化 =====
    async login () {
      const params = {
        userName: this.userName,
        password: this.passWord
      }
      try {
        const { code, msg, data } = await User.Login(params)
        if (code === 200) {
          localStorage.removeItem('receptionToken')
          localStorage.removeItem('receptionRefreshToken')
          if (typeof data === 'object' && data.token) {
            localStorage.setItem('receptionToken', data.token)
            if (data.refreshToken) {
              localStorage.setItem('receptionRefreshToken', data.refreshToken)
            }
          } else {
            localStorage.setItem('receptionToken', data)
          }
          sessionStorage.setItem('afterTokenRefresh', 'true')
          setTimeout(() => {
            window.location.reload()
          }, 100)
        } else {
          this.$message.error(msg || '登录失败，请稍后重试')
        }
      } catch (error) {
        this.$message.error('网络错误，请检查网络连接')
      }
    },
    async initializePage () {
      try {
        const isAfterRefresh = sessionStorage.getItem('afterTokenRefresh')
        const existingToken = localStorage.getItem('receptionToken')
        if (!existingToken) {
          console.log('当前页面无token，准备自动登录...')
          await this.login()
          return
        }
        if (isAfterRefresh) {
          sessionStorage.removeItem('afterTokenRefresh')
          console.log('登录成功，当前页面:', this.$route.name)
        }
        this.syncNavigationState()
      } catch (error) {
        console.error('页面初始化失败:', error)
      }
    },
    syncNavigationState () {
      const routeToIndexMap = {
        'Home': 0,
        'ProductCenter': 1,
        'ProductDetails': 1,
        'Solution': 2,
        'SolutionDetails': 2,
        'News': 3,
        'NewsDetails': 3,
        'SuccessfulCase': 4,
        'SuccessfulCaseDetails': 4,
        'Purchase': 5,
        'AboutUs': 6,
        'ContactUs': 7
      }
      const currentIndex = routeToIndexMap[this.$route.name]
      if (currentIndex !== undefined) {
        this.$LocalCache.setCath('navigationBarIndex', currentIndex)
        this.topActiveIndex = currentIndex
      }
    }
  },
  mounted () {
    // 获取产品分类和成功案例分类（供下拉菜单使用）
    this.fetchProductCategories()
    this.fetchSuccessfulCategories()

    if (!this.$LocalCache.getCache('navigationBarIndex')) {
      this.$LocalCache.setCath('navigationBarIndex', 0)
    }
    this.syncNavigationState()
    this.topActiveIndex = parseInt(localStorage.getItem('navigationBarIndex')) || 0
  },
  watch: {
    '$route' (to, from) {
      let targetIndex = 0
      switch (to.name) {
        case 'Home': targetIndex = 0; break
        case 'ProductCenter':
        case 'ProductDetails': targetIndex = 1; break
        case 'Solution':
        case 'SolutionDetails': targetIndex = 2; break
        case 'News':
        case 'NewsDetails': targetIndex = 3; break
        case 'SuccessfulCase':
        case 'SuccessfulCaseDetails': targetIndex = 4; break
        case 'Purchase': targetIndex = 5; break
        case 'AboutUs': targetIndex = 6; break
        case 'ContactUs': targetIndex = 7; break
        default: return
      }
      this.$LocalCache.setCath('navigationBarIndex', targetIndex)
      this.topActiveIndex = targetIndex
    }
  }
}
</script>

<style lang="scss">
// 引入公共css
@import "./assets/css/common.css";
$--color-primary: #0a943b;
$--font-path: "~element-ui/lib/theme-chalk/fonts";
@import "~element-ui/packages/theme-chalk/src/index";

#app {
  width: 100%;
  height: 1080px;
  display: flex;
  flex-direction: column;
  font-size: 16px;

  .el-message__content {
    font-size: 16px;
  }

  // 顶部绿色导航条样式
  .topNavigation {
    width: 100%;
    padding: 20px 0;
    background-color: #0a943b;
    display: flex;
    align-items: center;
    justify-content: center;

    .topNav-container {
      width: 100%;
      max-width: 1206px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;

      .topNav-menu {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 0;

        li {
          color: white;
          font-size: 16px;
          height: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;
          box-sizing: border-box;

          &:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }

          &.active {
            background-color: rgba(255, 255, 255, 0.2);
            font-weight: 500;
          }

          &:not(:last-child):after {
            content: "";
            position: absolute;
            right: 0;
            top: 0;
            width: 1px;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.3);
          }

          .nav-dropdown {
            display: inline-flex;
            align-items: center;
            width: 100%;
            height: 100%;
            justify-content: center;
            .nav-link {
              color: white;
              font-size: 16px;
              cursor: pointer;
              &:hover {
                background-color: rgba(255, 255, 255, 0.1);
              }
            }
          }
        }
      }
    }
  }

  .homeContent {
    width: 100%;
  }

  .homeHeader {
    width: 100%;
    height: 100px;
    display: flex;

    .logo {
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 54px;
        margin-left: 76px;
      }
    }

    .navigationBar {
      width: 775px;
      height: 100px;
      margin-left: 140px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      li {
        font-size: 18px;
        height: 20px;
        display: flex;
        align-items: center;
        position: relative;

        &:hover {
          cursor: pointer;
        }

        .nav-dropdown {
          display: inline-flex;
          align-items: center;
          .nav-link {
            font-size: 18px;
            height: 20px;
            display: flex;
            align-items: center;
            color: #000;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .navigationBarChange {
        color: #0a943b !important;
        margin-top: 20px;
        transition: all 0.5s;
      }

      // 各导航项选中样式（完全保留原有）
      li:nth-child(1).navigationBarChange {
        &:after {
          width: 36px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 17px;
        }
      }
      li:nth-child(2).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(3).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(4).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(5).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(6).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(7).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
      li:nth-child(8).navigationBarChange {
        &:after {
          width: 64px;
          height: 6px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -40px;
          left: 0;
        }
        &:before {
          width: 2px;
          height: 22px;
          content: "";
          background-color: #0a943b;
          position: absolute;
          top: -30px;
          left: 31px;
        }
      }
    }

    .phone {
      width: 220px;
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 198px;
      color: #0a943b;

      .phoneBox {
        width: 100%;
        height: 54px;
        display: flex;
        img {
          width: 24px;
          height: 54px;
        }
        .phoneBoxRight {
          flex: 1;
          display: flex;
          flex-direction: column;
          .phoneBoxRight_top {
            width: 100%;
            height: 20px;
            font-size: 18px;
            font-family: Source Han Sans CN;
          }
          .phoneBoxRight_bottom {
            width: 100%;
            height: 30px;
            font-size: 30px;
            margin-top: 6px;
          }
        }
      }
    }
  }

  .homeFoot {
    width: 100%;
    height: 190px;
    border-top: 1px solid #cdcdcd;

    .homeFoot_box {
      width: 100%;
      height: 190px;

      .homeFoot_boxTop {
        width: 100%;
        height: 110px;
        border-bottom: 1px solid #cdcdcd;
        display: flex;
        justify-content: center;

        .boxContent {
          width: 1206px;
          height: 110px;
          display: flex;
          align-items: center;
        }

        .boxLeft {
          width: 356px;
          height: 62px;
          position: relative;
          li {
            &:nth-child(1) {
              width: 100%;
              height: 40px;
              font-size: 16px;
              font-weight: 500;
              span { color: #666666; }
            }
            &:nth-child(2) {
              width: 100%;
              height: 40px;
              font-size: 14px;
            }
          }
          &:after {
            content: "";
            width: 1px;
            height: 34px;
            background-color: #b7b7b7;
            position: absolute;
            top: 16px;
            right: 0;
          }
        }

        .boxCenter {
          width: 500px;
          height: 62px;
          position: relative;
          margin-left: 40px;
          li {
            &:nth-child(1) {
              width: 100%;
              height: 40px;
              font-size: 16px;
              font-weight: 500;
              span { color: #666666; }
            }
            &:nth-child(2) {
              width: 100%;
              height: 40px;
              font-size: 14px;
              position: relative;
              .sy_yx {
                width: 23px;
                height: 17px;
                position: absolute;
                top: 0;
                left: 0;
              }
              .sy_dh {
                width: 22px;
                height: 22px;
                position: absolute;
                top: -4px;
                left: 212px;
              }
              .yx {
                font-size: 14px;
                margin-top: -2px;
                height: 40px;
                display: inline-block;
                position: absolute;
                top: 3px;
                left: 29px;
              }
              .dh {
                font-size: 16px;
                margin-top: -2px;
                height: 40px;
                display: inline-block;
                position: absolute;
                font-weight: 700;
                top: 2px;
                left: 237px;
              }
            }
          }
          &:after {
            content: "";
            width: 1px;
            height: 34px;
            background-color: #b7b7b7;
            position: absolute;
            top: 16px;
            right: 0;
          }
        }

        .boxRight {
          margin-left: 60px;
          display: flex;
          img {
            width: 100%;
            height: 83px;
          }
          .boxRight-li {
            margin-left: 20px;
            li { margin-top: 10px; }
            .gzh-li { margin-top: 20px; }
            .gzh { font-size: 14px; }
          }
        }
      }

      .homeFoot_boxBottom {
        width: 100%;
        height: 62px;
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .footContent {
          width: 1206px;
          height: 62px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 4px;
          .beian-icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin: 0 4px 0 0;
          }
          .beian-link {
            vertical-align: middle;
            color: #666;
            text-decoration: none;
            font-size: 14px;
            &:hover {
              text-decoration: underline;
              color: #0a943b;
            }
          }
        }
      }
    }
  }

  .message-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-icon-chat-dot-round {
      font-size: 30px;
    }
    .message-text {
      margin-top: 6px;
      font-weight: 800;
      font-size: 20px;
      color: #1D7E29;
    }
  }

  .nav-dropdown {
    .el-dropdown-selfdefine {
      display: inline-flex !important;
      align-items: center;
      outline: none;
    }
    .nav-link {
      display: inline-flex;
      align-items: center;
      height: 100%;
    }
  }
  .top-nav-dropdown {
    .el-dropdown-selfdefine {
      color: white !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue